import React, {useState, useEffect} from "react";
import {Table, Button, InputNumber} from "antd";
import {PlusOutlined, DeleteOutlined} from "@ant-design/icons";
import styles from "./MinimumPackagesInput.module.css";

export default function MinimumPackagesInput({value = [], setValue, disabled}) {
    const [rows, setRows] = useState(value.length > 0 ? value : []);

    useEffect(() => {
        if (value.length > 0) {
            setRows(value);
        }
    }, [value]);

    const handleChange = (index, field, newValue) => {
        const newRows = [...rows];
        newRows[index][field] = newValue;
        setRows(newRows);

        setValue(newRows);
    };

    const addRow = () => {
        const newRows = [...rows, {minPackageCount: 1, paymentAmount: 0}];
        setRows(newRows);
    };

    const removeRow = index => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
        setValue(newRows);
    };

    const columns = [
        {
            title: "Minimum Paket Adedi",
            dataIndex: "minPackageCount",
            key: "minPackageCount",
            width: "50%",
            render: (text, record, index) => (
                <InputNumber
                    value={text}
                    onChange={value => handleChange(index, "minPackageCount", value)}
                    disabled={disabled}
                    placeholder="Paket adedi girin"
                    min={1}
                    style={{width: "100%"}}
                />
            )
        },
        {
            title: "Kuryeye Ödenecek Tutar",
            dataIndex: "paymentAmount",
            key: "paymentAmount",
            width: "50%",
            render: (text, record, index) => (
                <InputNumber
                    value={text}
                    onChange={value => handleChange(index, "paymentAmount", value)}
                    disabled={disabled}
                    placeholder="Tutar girin"
                    min={0}
                    style={{width: "100%"}}
                />
            )
        }
    ];

    const actionColumn = {
        title: "",
        key: "action",
        width: "50px",
        render: (_, record, index) =>
            !disabled && (
                <Button
                    type="text"
                    icon={<DeleteOutlined />}
                    onClick={() => removeRow(index)}
                    danger
                />
            )
    };
    return (
        <div className={styles.minimumPackagesInput}>
            <Table
                dataSource={rows}
                columns={disabled ? columns : [...columns, actionColumn]}
                pagination={false}
                rowKey={(record, index) => index}
                bordered
            />
            {!disabled && (
                <Button
                    type="dashed"
                    onClick={addRow}
                    icon={<PlusOutlined />}
                    style={{marginTop: 10, width: "100%"}}
                >
                    Yeni Satır Ekle
                </Button>
            )}
        </div>
    );
}
